import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [ "fileInput", "uploadBtn", "preview" ]

  initialize() {
    this.locale = this.element.getAttribute("data-locale") || 'en'
  }

  upload(event) {
    // Disable upload button and show loading state
    if (this.hasUploadBtnTarget) {
      this.uploadBtnTarget.disabled = true
      this.uploadBtnTarget.innerHTML = '<i class="fas fa-spinner fa-spin"></i> Processing...'
    }

    // If there's no file selected, reset the button
    if (this.hasFileInputTarget && !this.fileInputTarget.value) {
      this.resetUploadButton()
      event.preventDefault()
      alert('Please select a file to upload')
      return false
    }
  }

  cancel() {
    // Hide preview
    if (this.hasPreviewTarget) {
      this.previewTarget.classList.add('d-none')
      this.previewTarget.innerHTML = ''
    }

    // Reset file input
    if (this.hasFileInputTarget) {
      this.fileInputTarget.value = ''
    }

    // Reset upload button
    this.resetUploadButton()
  }

  resetUploadButton() {
    if (this.hasUploadBtnTarget) {
      this.uploadBtnTarget.disabled = false
      this.uploadBtnTarget.innerHTML = '<i class="fas fa-upload"></i> Upload & Preview'
    }
  }
}
